export type TimeType = "opening" | "closing";

export const CONVERT_OTHER_TIMES_TO_LOCAL_TIMEZONE = true;
